import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { AuthShell, AuthInput } from "./Login";
import { ArrowRight } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!EMAIL_RE.test(email.trim())) {
      setError("Please enter a valid email address.");
      setLoading(false);
      return;
    }
    try {
      await register(name, email.trim(), password);
      toast.success("Account created — welcome to Joy!");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create account" subtitle="Save opportunities and track your applications.">
      <form onSubmit={submit} noValidate data-testid="register-form" className="space-y-5">
        <AuthInput label="Full name" value={name} onChange={setName} testid="register-name" />
        <AuthInput label="Email" type="email" value={email} onChange={setEmail} testid="register-email" />
        <AuthInput label="Password" type="password" value={password} onChange={setPassword} testid="register-password" />
        {error && <p className="text-destructive text-sm" data-testid="register-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="register-submit"
          className="w-full inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-navy text-white font-medium hover:bg-cobalt transition-colors disabled:opacity-60">
          {loading ? "Creating…" : "Create account"} <ArrowRight size={18} />
        </button>
      </form>
      <p className="text-sm text-slateink mt-6">
        Already a client? <Link to="/login" data-testid="link-login" className="text-cobalt font-medium hover:underline">Sign in</Link>
      </p>
    </AuthShell>
  );
}
